import { useClearDirty, useFormDirty, useGetPagesFormDirty, useIsDirty } from './form/useFormDirty'

// useFormSlot
import { useFormSlot } from './form/useFormSlot'

// useFormat
import { useFormat } from './formats/useFormat'

// useContentHeight
import { useContentHeight, useLayoutHeight } from './table/useContentHeight'
import { useDriver } from './table/useDriver'
import { useResetData } from './table/useResetData'
import { useTableSlot } from './table/useTableSlot'

// useWindowSizeFn
import { useWindowSizeFn } from './event/useWindowSizeFn'

// useMicroApp
import { getMicroData, sendMicroData } from './event/useMicroApp'

// onMountedOrActivated
import { onMountedOrActivated } from './core/useMountedOrActived'

// $baseMessage
import { $baseConfirm, $baseMessage, $baseNotify } from './core/useMessage'

// useDesign
import { useDesign } from './web/useDesign'
import { useIsScroll } from './web/useIsScroll'
import { useOrderCopy } from './web/useOrderCopy'

import { usePrinter } from './web/usePrinter'
// useTabs
import { useTabs } from './web/useTabs'

// form 验证
// import { useFormValidator } from './form/useFormValidator'

// 字典
import { useDict } from './dict/useDict'
import { useDictGroup } from './dict/useDictGroup'
import { useDictTree } from './dict/useDictTree'
import { useValidRulesModelHooks } from './form/useValidRulesModelHooks'
// 多语言
import { translateTitle } from '@/utils'
import { setDownTemplateName } from '@/utils/file/download'
import { getLablesInLanguage } from '@/utils/language'
import { useGrpcWeb } from './web/useGrpcWeb'

const t = translateTitle

export {
  $baseConfirm,
  $baseMessage,
  $baseNotify,
  getLablesInLanguage,
  getMicroData,
  onMountedOrActivated,
  sendMicroData,
  setDownTemplateName,
  t,
  useClearDirty,
  useContentHeight,
  useDesign,
  useDict,
  useDictGroup,
  useDictTree,
  useDriver,
  useFormat,
  useFormDirty,
  useFormSlot,
  useGetPagesFormDirty,
  useGrpcWeb,
  useIsDirty,
  useIsScroll,
  useLayoutHeight,
  useOrderCopy,
  usePrinter,
  useResetData,
  useTableSlot,
  useTabs,
  useValidRulesModelHooks,
  useWindowSizeFn,
}
